import { useMemo } from 'react';
import type { ROLE } from 'services/assist-api/entities/role/roles';
import { useAuth } from 'services/providers/auth.provider';

export default function useCurrentOrganisationAccess(): {
  currentOrganisationRoles: ROLE[];
  isAuthLoading: boolean;
} {
  const { me, isLoading: isAuthLoading } = useAuth();

  /**
   * All of the user's organisation-wide roles for current context, a combination of:
   *
   * their system level roles (e.g. ROLE_SITE_ADMIN)
   * their organisation/customer level roles (e.g. ROLE_ADMIN)
   *
   * Do not include area level roles here, as we don't want a role for the current area to grant
   * access to other areas across the system.
   */
  function combineRoleLists(systemRoles: ROLE[], customerRoles: ROLE[]): ROLE[] {
    return customerRoles.concat(systemRoles);
  }
  const currentOrganisationRoles: ROLE[] = useMemo(
    () => combineRoleLists((me?.systemRoles as ROLE[]) || [], (me?.customerRoles as ROLE[]) || []),
    [me?.systemRoles, me?.customerRoles]
  );

  return {
    currentOrganisationRoles,
    isAuthLoading
  };
}
